import { render, staticRenderFns } from "./help-header-button.vue?vue&type=template&id=796e64f9&scoped=true"
import script from "./help-header-button.vue?vue&type=script&lang=js"
export * from "./help-header-button.vue?vue&type=script&lang=js"
import style0 from "./help-header-button.vue?vue&type=style&index=0&id=796e64f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796e64f9",
  null
  
)

export default component.exports